/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
const routes = [
  {
    path: "/dashboard", // the url
    icon: "HomeIcon", // the component being exported from icons/index.js
    name: "Dashboard", // name that appear in Sidebar
  },
  {
    path: "/priorities",
    icon: "FormsIcon",
    name: "Priorities",
  },
  {
    icon: "FormsIcon",
    name: "Users",
    routes: [
      {
        path: "/management/active",
        name: "Active",
      },
      {
        path: "/management/archived",
        name: "Archived",
      },
    ],
  },
  {
    path: "/organization_settings",
    icon: "FormsIcon",
    name: "Organization Settings",
  },
  {
    icon: "FormsIcon",
    name: "Notifications",
    routes: [
      {
        path: "/notifications/custom",
        name: "Custom",
      },
      {
        path: "/notifications/reminders",
        name: "Reminders",
      },
    ],
  },
  {
    icon: "FormsIcon",
    name: "Conversations",
    routes: [
      {
        path: "/conversations/status/open",
        name: "Active",
      },
      {
        path: "/conversations/status/closed",
        name: "Archived",
      },
    ],
  },
  {
    icon: "Reports",
    name: "Reports",
    routes: [
      {
        path: "/general_report",
        name: "General",
      },
      {
        path: "/reports/support",
        name: "Support",
      },
      {
        path: "/reports/notifications",
        name: "Notifications",
      },
      {
        path: "/reports/notifications",
        name: "Export",
      },
    ],
  },
];

export default routes;
